"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerFileToJSON = exports.SignerFileFromJSONTyped = exports.SignerFileFromJSON = exports.instanceOfSignerFile = exports.SignerFileStatusEnum = exports.SignerFileTypeEnum = exports.attributeTypeMapSignerFile = void 0;
exports.attributeTypeMapSignerFile = [
    {
        name: "name",
        type: "string",
    },
    {
        name: "type",
        type: "string",
    },
    {
        name: "status",
        type: "string",
    },
    {
        name: "progress",
        type: "number",
    },
    {
        name: "error",
        type: "string",
    },
];
/**
 * @export
 */
exports.SignerFileTypeEnum = {
    Signer: "signer",
};
/**
 * @export
 */
exports.SignerFileStatusEnum = {
    Converting: "converting",
    Ok: "ok",
    FileDownloaded: "file downloaded",
    Downloading: "downloading",
    DownloadQueued: "download queued",
    Deleted: "deleted",
    Error: "error",
    _404Error: "404 Error",
    PasswordRequired: "password required",
    TooManyPages: "too many pages",
    FileTooLarge: "file too large",
    RetrieveError: "retrieve error",
    BadRequest: "bad request",
    BadAuth: "bad auth",
};
/**
 * Check if a given object implements the SignerFile interface.
 */
function instanceOfSignerFile(value) {
    if (!("name" in value) || value["name"] === undefined)
        return false;
    if (!("type" in value) || value["type"] === undefined)
        return false;
    if (!("status" in value) || value["status"] === undefined)
        return false;
    if (!("progress" in value) || value["progress"] === undefined)
        return false;
    if (!("error" in value) || value["error"] === undefined)
        return false;
    return true;
}
exports.instanceOfSignerFile = instanceOfSignerFile;
function SignerFileFromJSON(json) {
    return SignerFileFromJSONTyped(json, false);
}
exports.SignerFileFromJSON = SignerFileFromJSON;
function SignerFileFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        name: json["name"],
        type: json["type"],
        status: json["status"],
        progress: json["progress"],
        error: json["error"],
    };
}
exports.SignerFileFromJSONTyped = SignerFileFromJSONTyped;
function SignerFileToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        name: value["name"],
        type: value["type"],
        status: value["status"],
        progress: value["progress"],
        error: value["error"],
    };
}
exports.SignerFileToJSON = SignerFileToJSON;
